import * as URL from "../../helpers/Constants";
import axios from "axios";

export default class PMSDoctorServices {

    static getAllDoctorsByPharmacyId(pharmacyId, params) {
        return axios.get(`${URL.PMS_GET_ALL_DOCTORS_BY_PHARMACY_ID}/${pharmacyId}`, {
            ...PMSDoctorServices.getAuthHeader(),
            params,
        });
    }

    static getDoctorById(pharmacyId, id) {
        return axios.get(`${URL.PMS_GET_DOCTOR_BY_ID}/${id}`, PMSDoctorServices.getAuthHeader());
    }

    static getDoctorSelfProfileById() {
        return axios.get(`${URL.PMS_GET_DOCTOR_SELF_PROFILE}`, PMSDoctorServices.getAuthHeader());
    }

    static createDoctor(pharmacyId, data) {
        return axios.post(`${URL.PMS_CREATE_DOCTOR_BY_PHARMACY_ID}/${pharmacyId}`, data, PMSDoctorServices.getAuthHeader());
    }

    static updateDoctorById(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_DOCTOR_BY_ID}/${id}`, data, PMSDoctorServices.getAuthHeader());
    }

    static deleteDoctorById(id) {
        return axios.delete(`${URL.PMS_DELETE_DOCTOR_BY_ID}/${id}`, PMSDoctorServices.getAuthHeader());
    }

    static updateDoctorSelfProfile(data) {
        return axios.put(URL.PMS_UPDATE_DOCTOR_SELF_PROFILE, data, PMSDoctorServices.getAuthHeader());
    }

    static getAuthHeader() {
        return {headers: {Authorization: `Bearer ${localStorage.getItem("oushodsheba_access_token")}`}};
    }
}
